import type { TourDefinition } from '../training/tours';

/**
 * Тур дерева управлінських одиниць (/mgmt/units). Ідентифікатор для реєстрації: 'mgmt-tree'.
 * Цілі — атрибути data-tour у MgmtLayout, сторінці «Одиниці» й дереві (features/mgmt/units/*).
 */
export const MGMT_TREE_TOUR_ID = 'mgmt-tree';

export const MGMT_TREE_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Дерево одиниць',
  summary: 'Розділи управлінського контуру, подання одиниць, дерево «ціль → напрям → проєкт → завдання» зі станом і прогнозом.',
  missingHint: 'Відкрийте розділ «Управлінський контур» → «Одиниці» — підказки прив’яжуться до дерева.',
  steps: [
    {
      id: 'nav',
      target: 'mgmt-nav',
      title: 'Управлінський контур',
      body: '«Потребують дії» — блокери на погодження, результати на приймання, рішення й запити звіту до вас; «Одиниці» — структура робіт. Дашборд, координації, цілі й огляди бачить коло управління.',
      placement: 'bottom',
    },
    {
      id: 'view',
      target: 'mgmt-units-view',
      title: 'Дерево, реєстр чи мої',
      body: '«Дерево» показує підпорядкування, «Реєстр» — плаский перелік із фільтрами, «Мої» — одиниці, де ви виконавець, ініціатор чи учасник.',
      placement: 'bottom',
    },
    {
      id: 'tree',
      target: 'mgmt-tree',
      title: 'Від цілі до завдання',
      body: 'Ціль S → напрям P → проєкт → завдання. Код (P3.2) — адреса одиниці в розмовах і звітах. Стрілки ←/→ згортають і розгортають гілку, Enter відкриває паспорт.',
    },
    {
      id: 'health',
      target: 'mgmt-tree',
      title: 'Стан і прогноз',
      body: '«Є ризик» і «Заблоковано» — сигнал для координації; прогноз поруч зі строком показує, коли одиницю реально буде виконано. Приховані гілки позначено «Обмежений доступ».',
    },
    {
      id: 'passport',
      target: 'mgmt-tree',
      title: 'Паспорт одиниці',
      body: 'У паспорті — звіти й прогнози виконавця, блокери, рішення, приймання результату й статуси. Звіт подає виконавець, результат приймає ініціатор.',
    },
  ],
};
